/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type BatchUpdateCargosMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.CargoBatchUpdateInput>;
}>;


export type BatchUpdateCargosMutation = {
  __typename?: 'Mutation',
  batchUpdateCargos?: Array<{
    __typename?: 'Cargo',
    id: number
  } | null> | null
};


export const BatchUpdateCargosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BatchUpdateCargos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CargoBatchUpdateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchUpdateCargos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<BatchUpdateCargosMutation, BatchUpdateCargosMutationVariables>;